import { useState } from 'react';
import { Switch } from '../../ds';
import { WebModal } from '../../shell/WebModal';

export type FlashcardFace = 'front' | 'back';

export interface FlashcardSettings {
  startFace: FlashcardFace;
  shuffle: boolean;
}

interface Props {
  settings: FlashcardSettings;
  onClose: () => void;
  onApply: (settings: FlashcardSettings) => void;
  /// Đặt lại bộ thẻ về trạng thái ban đầu (thẻ 1, xoá hết đánh dấu) — hành động tức thì,
  /// tách khỏi Huỷ/Áp dụng vì không phải một "cài đặt" được lưu lại.
  onReset: () => void;
}

function FaceOption({ label, active, onClick }: { label: string; active: boolean; onClick: () => void }) {
  return (
    <button
      onClick={onClick}
      style={{
        flex: 1,
        height: 44,
        borderRadius: 'var(--radius-control)',
        background: active ? 'var(--cta-default)' : 'var(--surface-page)',
        border: active ? 'none' : '1px solid var(--border-default)',
        color: active ? '#fff' : 'var(--ink)',
        cursor: 'pointer',
        fontFamily: 'var(--font-vi)',
        fontWeight: 600,
        fontSize: 14,
      }}
    >
      {label}
    </button>
  );
}

export function FlashcardSettingsModal({ settings, onClose, onApply, onReset }: Props) {
  const [startFace, setStartFace] = useState<FlashcardFace>(settings.startFace);
  const [shuffle, setShuffle] = useState(settings.shuffle);

  return (
    <WebModal onClose={onClose} width={420}>
      <div style={{ padding: 24, display: 'flex', flexDirection: 'column', gap: 20, fontFamily: 'var(--font-vi)' }}>
        <h2 style={{ fontSize: 19, fontWeight: 700, color: 'var(--ink)', margin: 0 }}>Cài đặt Flashcard</h2>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          <div style={{ fontSize: 13.5, fontWeight: 700, color: 'var(--ink)' }}>Mặt hiển thị đầu tiên</div>
          <div style={{ display: 'flex', gap: 8 }}>
            <FaceOption label="Mặt trước" active={startFace === 'front'} onClick={() => setStartFace('front')} />
            <FaceOption label="Mặt sau" active={startFace === 'back'} onClick={() => setStartFace('back')} />
          </div>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 16 }}>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 13.5, fontWeight: 700, color: 'var(--ink)' }}>Trộn thứ tự thẻ</div>
            <div style={{ fontSize: 12, color: 'var(--text-secondary)', marginTop: 2 }}>Xáo trộn thứ tự thẻ hiển thị trong bộ này</div>
          </div>
          <Switch checked={shuffle} onChange={setShuffle} />
        </div>

        <button
          onClick={onReset}
          style={{
            height: 44,
            borderRadius: 'var(--radius-control)',
            border: '1px solid var(--border-default)',
            background: 'var(--surface-page)',
            color: 'var(--ink)',
            cursor: 'pointer',
            fontFamily: 'var(--font-vi)',
            fontWeight: 600,
            fontSize: 14,
          }}
        >
          Đặt lại bộ thẻ về ban đầu
        </button>

        <div style={{ display: 'flex', gap: 12 }}>
          <button
            onClick={onClose}
            style={{
              height: 48,
              padding: '0 20px',
              borderRadius: 'var(--radius-control)',
              background: 'transparent',
              border: '1px solid var(--border-default)',
              color: 'var(--text-secondary)',
              cursor: 'pointer',
              fontFamily: 'var(--font-vi)',
              fontWeight: 600,
              fontSize: 15,
            }}
          >
            Huỷ
          </button>
          <button
            onClick={() => onApply({ startFace, shuffle })}
            style={{
              flex: 1,
              height: 48,
              borderRadius: 'var(--radius-control)',
              background: 'var(--cta-default)',
              color: '#fff',
              border: 'none',
              cursor: 'pointer',
              fontFamily: 'var(--font-vi)',
              fontWeight: 600,
              fontSize: 16,
            }}
          >
            Áp dụng
          </button>
        </div>
      </div>
    </WebModal>
  );
}
